document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector("swiper-slider, swiper-video-slider, swiper-featured-collections, swiper-faq-slider")) {
    const swiperScriptURL = document.querySelector("[data-swiper-script]")?.dataset.swiperScript;
    if (!swiperScriptURL) return;
    const swiperScript = document.createElement("script");
    swiperScript.src = swiperScriptURL;
    swiperScript.async = true;
    swiperScript.onload = declareSwiperCustomElement;
    document.head.appendChild(swiperScript);
  }
});

function declareSwiperCustomElement() {
  if (!!customElements.get("swiper-slider")) return;
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.slideContainer = this.querySelector("[data-swiper]:not([data-swiper-thumbs])");
      this.slides = this.querySelectorAll("[data-swiper-slide]");
      this.isVideoWrapper = this.querySelector("[data-video-wrapper]");
      this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions());
      this.activeIndex = 0;
      this.initialized = false;
      this.resizeBound = false;
      if (this.dataset.swiperThumbs) {
        this.thumbnails = this.querySelector("[data-swiper-thumbs]");
      }
      this.boundInitializeSwiper = this.initializeSwiper.bind(this);
    }

    connectedCallback() {
      if (this.dataset.customEvent) {
        this.attachCustomListeners(this.dataset.customEvent);
      }
      if (this.slideContainer && this.slides.length > 0) {
        this.initializeSwiper();
      } else {
        console.warn("SwiperSlider - Slider or Slides Not Found");
      }
    }

    attachCustomListeners(customEvent) {
      switch (customEvent) {
        case "reinitialize":
          this.addEventListener("reinitialize-swiper", this.boundInitializeSwiper);
          break;
      }
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
      if (this.dataset.customEvent) {
        switch (this.dataset.customEvent) {
          case "reinitialize":
            this.removeEventListener("reinitialize-swiper", this.boundInitializeSwiper);
            break;
        }
      }
    }

    applyDefaultOptions(options) {
      if (options.loop === undefined) {
        options.loop = true;
      }
      if (options.speed === undefined) {
        options.speed = 400;
      }
      return options;
    }

    getSliderOptions() {
      try {
        return JSON.parse(this.dataset.swiperOptions);
      } catch (err) {
        console.log(err);
        return {};
      }
    }

    initializeSwiper() {
      if (window.Swiper && !this.initialized) {
        this.initialized = true;
        const swipperWrapper = this;
        if (this.thumbnails) {
          this.setThumbnails();
        }
        this.sliderOptions.on = {
          slideChange: function () {
            let activeIndex = this.activeIndex;
            document.dispatchEvent(
              new CustomEvent("thumbnail-changed", {
                detail: {
                  slide: this.slides[this.activeIndex],
                },
              })
            );
            if (this.thumbnails) {
              this.thumbs.swiper.slideTo(activeIndex > 0 ? activeIndex - 1 : 0);
            }
          },
          afterInit: function () {
            swipperWrapper.dispatchEvent(new CustomEvent("swiper:init", { bubbles: true }));
          },
        };
        this.slider = new Swiper(this.slideContainer, this.sliderOptions);

        // Fix for loop + centeredSlides + auto slidesPerView:
        // Swiper may incorrectly set the active class on a duplicated slide.
        // Force slide to the correct initial position after initialization.
        if (this.sliderOptions.loop && this.sliderOptions.centeredSlides && this.sliderOptions.slidesPerView === "auto") {
          // Use slideToLoop to navigate to the real slide index 0
          this.slider.slideToLoop(0, 0, false);
        }

        this.initializeSliderEventListeners();
      } else if (!window.Swiper) {
        console.warn("SwiperSlider - Swiper.js not found");
      }
      this.bindResizeEvent();
    }

    bindResizeEvent() {
      if (!this.resizeBound) {
        window.addEventListener("resize", this.handleResize.bind(this));
        this.resizeBound = true;
      }
    }

    handleResize(e) {
      if (this.slider) {
        setTimeout(() => {
          this.slider.updateSize();
        }, 300);
      }
    }

    setThumbnails() {
      const thumbsSlideContainer = this.thumbnails;
      const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
      const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
      this.sliderOptions.thumbs = { swiper: thumbnailsSlider };
    }

    initializeSliderEventListeners() {
      if (this.isVideoWrapper) {
        this.slider.on("slideChange", () => {
          const activeIndex = this.slider.realIndex !== undefined ? this.slider.realIndex : this.slider.activeIndex;
          this.slides.forEach((slide, index) => {
            if (index === activeIndex || !slide.dataset?.videoWrapper) {
              return;
            }
            const deferredMediaElements = slide.querySelectorAll("deferred-media");
            deferredMediaElements.forEach((deferredMedia) => {
              if (!deferredMedia.hasAttribute("autoplay") && typeof deferredMedia.pauseMedia === "function") {
                deferredMedia.pauseMedia();
              }
            });
          });
        });
      }
    }
  }
  customElements.define("swiper-slider", SwiperSlider);

  // Reel Modal video navigation & slider-related video controls
  if (!customElements.get("swiper-video-slider")) {
    class SwiperVideoSlider extends SwiperSlider {
      constructor() {
        super();
      }

      connectedCallback() {
        super.connectedCallback();
        this.initializeSliderEventListeners();
      }

      // Navigate to the target slide and play the matching video
      goToSlide(index) {
        if (this.slider) {
          this.slider.slideTo(index, 333, false);
          const slideVideo = this.slider.slides[this.slider.activeIndex].querySelector("video");
          if (slideVideo) {
            slideVideo.currentTime = 0;
          } else {
            console.warn("Slide video not found");
          }
        } else {
          console.warn("SwiperSlider - Swiper not initialized in goToSlide method");
        }
      }

      // Handles play & pause on slide change
      handleSlideMedia(prevSlide, currentSlide) {
        if (currentSlide) {
          const currentSlideMedia = currentSlide.querySelector("video");
          if (currentSlideMedia) {
            currentSlideMedia.currentTime = 0;
            currentSlideMedia.play();
          }
        }

        if (prevSlide != undefined) {
          const prevSlideMedia = prevSlide.querySelector("video");
          if (prevSlideMedia) {
            prevSlideMedia.pause();
          }
        }
      }

      initializeSliderEventListeners() {
        if (this.slider) {
          this.slider.on("slideChange", () => {
            const prevSlide = this.slider.slides[this.slider.previousIndex];
            const currentSlide = this.slider.slides[this.slider.activeIndex];
            if (currentSlide) {
              currentSlide.removeAttribute("video-paused");
            }
            this.handleSlideMedia(prevSlide, currentSlide);
          });
        }

        // Play & pause on click
        if (this.isVideoSlider != null) {
          this.slides.forEach((slide) => {
            slide.addEventListener("click", () => {
              const slideVideo = slide.querySelector("video");

              if (slideVideo) {
                if (slideVideo.paused) {
                  slide.removeAttribute("video-paused");
                  slideVideo.play();
                } else {
                  slide.setAttribute("video-paused", "");
                  slideVideo.pause();
                }
              }
            });
          });
        }
      }
    }

    customElements.define("swiper-video-slider", SwiperVideoSlider);
  }

  // Featured collections slider with modal focus support
  if (!customElements.get("swiper-featured-collections")) {
    class SwiperFeaturedCollections extends SwiperSlider {
      // Expanded modal widths for different breakpoints
      static EXPANDED_WIDTH_DESKTOP = 782;
      static EXPANDED_WIDTH_TABLET = 600;

      constructor() {
        super();
        this.modalScrollRequestHandler = this.handleModalScrollRequest.bind(this);
        this.modalOpenHandler = this.handleModalOpen.bind(this);
        this.modalToggleHandler = this.handleModalToggle.bind(this);
      }

      connectedCallback() {
        super.connectedCallback();
        this.initializeModalListener();
      }

      initializeModalListener() {
        // Listen for scroll request events (before modal opens)
        document.addEventListener("sb-featured-collection:scroll-request", this.modalScrollRequestHandler);
        // Listen for modal open events (for closing other modals)
        document.addEventListener("sb-featured-collection:open", this.modalOpenHandler);
        // Listen for any modal toggle events (open or close) to update slider dimensions
        document.addEventListener("sb-featured-collection:toggle", this.modalToggleHandler);
      }

      isTabletOrHigher() {
        return window.matchMedia("(min-width: 767px)").matches;
      }

      handleModalScrollRequest(event) {
        if (!this.isTabletOrHigher() || !this.slider) {
          return;
        }

        const requestingModal = event.detail.source;
        const slides = this.slider.slides;
        let targetIndex = -1;

        for (let i = 0; i < slides.length; i++) {
          if (slides[i].contains(requestingModal)) {
            targetIndex = i;
            break;
          }
        }

        if (targetIndex !== -1) {
          const slide = this.slider.slides[targetIndex];
          const containerEl = this.slider.el;
          
          if (slide && containerEl) {
            const slideRect = slide.getBoundingClientRect();
            const containerRect = containerEl.getBoundingClientRect();
            const expandedWidth = window.innerWidth >= 1024 
              ? SwiperFeaturedCollections.EXPANDED_WIDTH_DESKTOP 
              : SwiperFeaturedCollections.EXPANDED_WIDTH_TABLET;
            const padding = 32;
            const expandedRightEdge = slideRect.left + expandedWidth;
            
            const isLeftEdgeVisible = slideRect.left >= containerRect.left + padding;
            const isRightEdgeVisible = slideRect.right <= containerRect.right - padding;
            const rightOverflow = expandedRightEdge - (containerRect.right - padding);
            
            let hasExpandedCardToLeft = false;
            const allSlides = this.slider.slides;
            for (let i = 0; i < allSlides.length; i++) {
              if (i === targetIndex) continue;
              
              const otherSlide = allSlides[i];
              const otherSlideRect = otherSlide.getBoundingClientRect();
              
              // Check for expanded modal (affects right edge calculation)
              const otherModal = otherSlide.querySelector('._sb-featured-collection__modal');
              const isOtherExpanded = otherModal && otherModal.classList.contains('active');
              
              // Use expanded width if modal is active
              let otherRightEdge = otherSlideRect.right;
              if (isOtherExpanded) {
                const expandedWidth = window.innerWidth >= 1024 
                  ? SwiperFeaturedCollections.EXPANDED_WIDTH_DESKTOP 
                  : SwiperFeaturedCollections.EXPANDED_WIDTH_TABLET;
                otherRightEdge = otherSlideRect.left + expandedWidth;
              }
              
              // Check if slide is to the left and expanded modal extends past target
              if (otherSlideRect.right <= slideRect.left && isOtherExpanded && otherRightEdge > slideRect.left) {
                hasExpandedCardToLeft = true;
                break;
              }
              
              // Early break: use expanded right edge to account for expanded modals
              if (otherRightEdge > slideRect.left) {
                break;
              }
            }
            
            const hasOverflow = rightOverflow > 0;
            const needsScroll = !hasExpandedCardToLeft && (!isLeftEdgeVisible || !isRightEdgeVisible || hasOverflow);
            
            if (needsScroll) {
              const currentTranslate = this.slider.getTranslate();
              const wrapperEl = this.slider.wrapperEl;
              let scrollAdjustment = 0;
              
              if (!isLeftEdgeVisible) {
                const leftOverflow = (containerRect.left + padding) - slideRect.left;
                scrollAdjustment = leftOverflow;
              } else {
                scrollAdjustment = -rightOverflow;
              }
              
              if (scrollAdjustment !== 0) {
                const newTranslate = currentTranslate + scrollAdjustment;
                wrapperEl.style.transition = 'transform 400ms ease-out';
                this.slider.setTranslate(newTranslate);
                
                setTimeout(() => {
                  wrapperEl.style.transition = '';
                  this.slider.updateProgress();
                  this.slider.updateSlidesClasses();
                }, 400);
              } else {
                this.slider.slideTo(targetIndex, 400, false);
              }
            }
          } else {
            this.slider.slideTo(targetIndex, 400, false);
          }
        }
      }

      handleModalOpen(event) {
        // Used for closing other modals
      }

      handleModalToggle(event) {
        if (!this.isTabletOrHigher() || !this.slider) {
          return;
        }

        const toggledModal = event.detail.source;
        const isOpening = event.detail.isOpening;
        const slides = this.slider.slides;
        let slideIndex = -1;

        for (let i = 0; i < slides.length; i++) {
          if (slides[i].contains(toggledModal)) {
            slideIndex = i;
            break;
          }
        }

        if (slideIndex === -1) return;

        setTimeout(() => {
          this.slider.update();

          if (!isOpening) {
            setTimeout(() => {
              this.slider.update();
              this.ensureSlideVisible(slideIndex);
            }, 100);
          }
        }, 300);
      }

      ensureSlideVisible(slideIndex) {
        const slide = this.slider.slides[slideIndex];
        if (!slide) return;

        const totalSlides = this.slider.slides.length;
        if (slideIndex < totalSlides - 2) return;

        const containerEl = this.slider.el;
        const slideRect = slide.getBoundingClientRect();
        const containerRect = containerEl.getBoundingClientRect();
        const modal = slide.querySelector('._sb-featured-collection__modal');
        const isExpanded = modal && modal.classList.contains('active');
        
        let checkWidth = slideRect.width;
        if (isExpanded) {
          const expandedWidth = window.innerWidth >= 1024 
            ? SwiperFeaturedCollections.EXPANDED_WIDTH_DESKTOP 
            : SwiperFeaturedCollections.EXPANDED_WIDTH_TABLET;
          const expandedRightEdge = slideRect.left + expandedWidth;
          checkWidth = expandedRightEdge - slideRect.left;
        }

        const padding = 32;
        const rightEdge = slideRect.left + checkWidth;
        const overhang = rightEdge - (containerRect.right - padding);

        if (overhang > 0) {
          const currentTranslate = this.slider.translate;
          const newTranslate = currentTranslate - overhang;
          const wrapperEl = this.slider.wrapperEl;
          
          wrapperEl.style.transition = 'transform 300ms ease-out';
          this.slider.setTranslate(newTranslate);

          setTimeout(() => {
            wrapperEl.style.transition = '';
            this.slider.updateProgress();
            this.slider.updateSlidesClasses();
          }, 300);
        }
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("sb-featured-collection:scroll-request", this.modalScrollRequestHandler);
        document.removeEventListener("sb-featured-collection:open", this.modalOpenHandler);
        document.removeEventListener("sb-featured-collection:toggle", this.modalToggleHandler);
      }
    }

    customElements.define("swiper-featured-collections", SwiperFeaturedCollections);
  }

  // FAQ slider with click-to-scroll functionality
  if (!customElements.get("swiper-faq-slider")) {
    class SwiperFaqSlider extends SwiperSlider {
      initializeSliderEventListeners() {
        if (!this.slider) return;

        this.slides.forEach((slide, index) => {
          slide.addEventListener("click", () => {
            this.slider.slideTo(index);
          });
        });
      }
    }

    customElements.define("swiper-faq-slider", SwiperFaqSlider);
  }
}
